import { NationalityMaster, LicenseTypeMaster, EducationMdl, numYearMdl, ProfessionMdl, RestraintsMaster, RelationMdl, RoadConviction, CityMaster, RegionMaster, MarStatusMaster, GenderMaster } from "./BindMdl";
import { mdlChildrenUnder16List } from "./mdlChildrenUnder16List";
import { mdlLicenceForEachCountryList } from "./mdlLicenceForEachCountryList";
import { MotorDriverMdl } from "./MotorDriverMdl";

export class mdlBindInfo {
    public RegNo: string;
    public NationalityMasterList: Array<NationalityMaster> = new Array<NationalityMaster>();
    public LicenceTypeList: Array<LicenseTypeMaster> = new Array<LicenseTypeMaster>();
    public eduList: Array<EducationMdl> = new Array<EducationMdl>();
    public NumYearList: Array<numYearMdl> = new Array<numYearMdl>();
    public profList: Array<ProfessionMdl> = new Array<ProfessionMdl>();
    public ChildrenUnder16List: Array<mdlChildrenUnder16List> = new Array<mdlChildrenUnder16List>();
    public LicenceForEachCountryList: Array<mdlLicenceForEachCountryList> = new Array<mdlLicenceForEachCountryList>();
    public restrainList: Array<RestraintsMaster> = new Array<RestraintsMaster>();
    public relationList: Array<RelationMdl> = new Array<RelationMdl>();
    public RoadConvictionList: Array<RoadConviction> = new Array<RoadConviction>();
    public CityMasterList: Array<CityMaster> = new Array<CityMaster>();
    public RegionMasterList: Array<RegionMaster>=new Array<RegionMaster>();
    public MarStatusList: Array<MarStatusMaster>=new Array<MarStatusMaster>() ;
    public driverListObj: Array<MotorDriverMdl> = new Array<MotorDriverMdl>();
    public GenderList: Array<GenderMaster>=new Array<GenderMaster>();
    public StatusCode:string;
    public StatusDesc:string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlBindInfo.ts